import type { DataAttributesProps } from '../../../internal/types/dataAttributesTypes';

/**
 * Фильтрует свойства, оставляет только data аттрибуты (начинаются с `data-`)
 */
export const getDataAttributesProps = (data: DataAttributesProps) => {
    return Object.keys(data).reduce<DataAttributesProps>((acc, key) => {
        if (!key.startsWith('data-')) {
            return acc;
        }

        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- startWith не сужает тип
        const typedKey = key as `data-${string}`;

        acc[typedKey] = data[typedKey];
        return acc;
    }, {});
};
